const defaultFields = () => ({
	user: {
		name: null,
		email: null,
		password: null,
		password_confirmation: null,
	},
	company: {
		name: null,
		address: null,
		logo: null,
	},
	settings: {
		proposal_email_template: null,
		invoice_email_template: null,
		payment_terms_template: [],
		proposal_terms_template: null,
		bank_account: null,
	},
})

const defaultErrors = () => ({
	user: {
		email: null,
		password: null,
		password_confirmation: null,
	},
	company: {
		name: null,
		address: null,
		logo: null,
	},
	settings: {
		proposal_email_template: null,
		invoice_email_template: null,
		payment_terms_template: null,
		proposal_terms_template: null,
		bank_account: null,
	},
})

export {
	defaultErrors,
	defaultFields,
}
